module.exports = __webpack_public_path__ + "media/images/components/landing_pages/reassurance_cards/efficient-2f117cd5ffab30d938c79610a869d88d.png";